import api from '@/api/notification/notification';

const state = {
  newCount: 0,
  page: 1,
  nextPage: '',
  previousPage: '',
  notifications: [],
  updated_at: '',
};

// getters
const getters = {};

// mutations
const mutations = {
  removeNotifications(state) {
    state.newCount = 0;
    state.page = 1;
    state.nextPage = '';
    state.previousPage = '';
    state.notifications = [];
  },

  setNewCount(state, { count }) {
    state.newCount = count;
  },

  setNotifications(state, { prev, next, notifications }) {
    state.previousPage = prev;
    state.nextPage = next;
    state.notifications = notifications;
  },

  addMoreNotifications(state, {
    page, prev, next, notifications,
  }) {
    state.page = page;
    state.previousPage = prev;
    state.nextPage = next;
    state.notifications.push(...notifications);
  },

  addOneNotification(state, { notification }) {
    state.newCount += 1;
    state.notifications.unshift(notification);
  },

  updateNotification(state, { notification }) {
    const index = state.notifications.findIndex((el) => el.uuid === notification.uuid);
    state.notifications[index] = notification;
    state.updated_at = new Date();
    // force re render of computed fields when single notification is updated in array
    // (computed don't updated nested field)
    state.notifications = JSON.parse(JSON.stringify(state.notifications));
  },

  updateAllNotificationsAsRead(state) {
    state.notifications = state.notifications.map((el) => {
      const local = el;
      local.is_read = true;
      return local;
    });
  },
};

// actions
const actions = {
  async fetchNewCount({ commit }) {
    // empty data
    commit('removeNotifications');

    try {
      const response = await api.getNewNotificationsCount();
      commit('setNewCount', {
        count: response.data.count,
      });
      return response.data;
    } catch (err) {
      return null;
    }
  },

  async fetchNotifications({ commit }) {
    // empty data
    commit('removeNotifications');

    try {
      const response = await api.getNotifications();
      commit('setNotifications', {
        notifications: response.data.results,
        prev: response.data.previous,
        next: response.data.next,
      });
      return response.data;
    } catch (err) {
      if (err.msg) {
        console.log(err.msg);
      }
      return null;
    }
  },

  async fetchNextNotifications({ commit, state }) {
    if (!state.nextPage) return null;

    try {
      const newPage = state.page + 1;
      const response = await api.getNotifications({ page: newPage });
      commit('addMoreNotifications', {
        page: newPage,
        prev: response.data.previous,
        next: response.data.next,
        notifications: response.data.results,
      });
      return response.data;
    } catch (err) {
      if (err.msg) {
        console.log(err.msg);
      }
      return null;
    }
  },

  async markAsRead({ commit }, { id }) {
    try {
      const response = await api.markAsReadNotification(id);
      commit('updateNotification', {
        notification: response.data,
      });
      return response.data;
    } catch (err) {
      if (err.msg) {
        console.log(err.msg);
      }
      return null;
    }
  },

  async markAllAsRead({ commit }) {
    try {
      const response = await api.markAllAsReadNotification();
      commit('updateAllNotificationsAsRead');
      return response.data;
    } catch (err) {
      if (err.msg) {
        console.log(err.msg);
      }
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
